import { OrganisationFeatureFlags } from "shared";

import { Card } from "../../../../../common/Atoms/Card";
import { CardContent } from "../../../../../common/Atoms/CardContent";
import { Divider } from "../../../../../common/Atoms/Divider";
import { SaveAndError } from "../SaveAndError";
import { useGetSelectedOrganisation } from "../../../../hooks/useGetSelectedOrganisation";

import { CustomDomain } from "./CustomDomain";
import { ForwardingAddress } from "./ForwardingAddress";
import { GeneralEmailSettings } from "./GeneralEmailSettings";
import { SenderProfilesRoot } from "./SenderProfiles/SenderProfilesRoot";

export function EmailRoot() {
  const currentOrg = useGetSelectedOrganisation();
  const showForwardingAddress = !!currentOrg?.featureFlags?.includes(OrganisationFeatureFlags.EMAIL_FORWARDING_ADDRESS);

  return (
    <Card>
      <CardContent>
        <SenderProfilesRoot />
        <Divider weight={ `light` } />
        <GeneralEmailSettings />
        <Divider weight={ `light` } />
        <CustomDomain/>
        { showForwardingAddress ? (
          <>
            <Divider weight={ `light` } />
            <ForwardingAddress />
          </>
        ) : null }
        <SaveAndError />
      </CardContent>
    </Card>
  );
}
